import styled from 'styled-components';

export const PreviewContainer = styled.div`
  border: 1px solid ${({ theme }) => theme.colorPalette.grey.grey4};
  border-radius: 8px;
  overflow: hidden;
  min-width: 260px;
  max-width: 260px;
  flex-shrink: 0;
  cursor: pointer;
  position: relative;
`;

export const PreviewImage = styled.img<{ isDark?: boolean }>`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;

  ${({ isDark }) => isDark && 'filter: brightness(0.8);'}
`;

export const DocContent = styled.div`
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const DocTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizePalette.medium};
  font-weight: 500;
  color: ${({ theme }) => theme.colorPalette.grey.grey9};
`;

export const FileIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  padding: 4px;
  background-color: ${({ theme }) => theme.colorPalette.turquoise.accent2};
`;

export const ModalImageWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

export const ModalImage = styled.img`
  max-height: 70vh;
  max-width: 100%;
  height: auto;
  width: auto;
  display: block;
`;

export const OpenSourceButton = styled.a`
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.45);
  border-radius: 6px;
  padding: 4px 6px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: white;
`;
